import { render, staticRenderFns } from "./AllPurchaseAndSaleMatching.vue?vue&type=template&id=15b6e5b4&scoped=true&"
import script from "./AllPurchaseAndSaleMatching.vue?vue&type=script&lang=js&"
export * from "./AllPurchaseAndSaleMatching.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15b6e5b4",
  null
  
)

export default component.exports